module.exports = __webpack_public_path__ + "img/leadership-1980-hu-yuzhi.7cc0c5a5.jpg";